module.exports = __webpack_public_path__ + "img/analytic.7b936e4c.svg";